module.exports = __webpack_public_path__ + "static/media/Coronavirus.4a4852f8.jpg";